import React from 'react'; 

const TitleEvenement = ({title, customClass}) => {
    return (
      <div className={`sub-title-evenement ${customClass}`}>{title} </div>
    )
}
export default TitleEvenement